import { default as Alert } from './Alert';
import { default as BodyEmpty } from './BodyEmpty';

const EXPORT = { Alert, BodyEmpty };

export default EXPORT;
